import React, { useEffect, useState } from "react";
import {useField, useFormikContext} from "formik";
import { filterBy } from "@progress/kendo-data-query";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { FieldError } from "../Error/FieldError.jsx";

/**
 * Please read: use the PrimitiveDropdownList when you have a primitive array of data ["option 1", "option 2"]
 * if you have a complex set of data: [{id: 1, display: "option 1"}...], than use the original dropdown list or the combobox
 **/
export const PrimitiveDropdownListInput = ({ label, required, style, disabled = false, onChange, ...otherProps }) => {
    const [field] = useField(otherProps);
    const {
        filterable = false,
        data: propData = []
    } = otherProps;

    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(null);

    useEffect(() => {
        setData(propData);
    }, [propData]);

    const onBlur = () => {
        setData(propData);
        setFilter(null);
        field.onBlur(field.name);
    };

    const onClose = () => {
        setData(propData);
        setFilter(null);
    };

    const filterDropdownListData = (filter) => {
        const filteredData = propData.slice();
        return filterBy(filteredData, filter);
    };

    const onFilterChange = (event) => {
        setFilter(event.filter.value);
        setData(filterDropdownListData(event.filter));
    };

    const formikContext = useFormikContext();
    const { setFieldValue, values } = formikContext;

    // If disabled is a function, call it with the full form context
    const isDisabled = typeof disabled === 'function'
        ? disabled({
            ...formikContext,
            fieldName: otherProps.name,
            currentValue: values[otherProps.name]
        })
        : disabled;

    const handleChange = async (e) => {
        const newValue = e.target.value;

        if (onChange) {
            // Let the custom onChange handle field updates
            await onChange(e, {
                ...formikContext,
                fieldName: otherProps.name,
                newValue,
                previousValue: values[otherProps.name]
            });
        } else {
            // Default behavior: update Formik's state
            await setFieldValue(otherProps.name, newValue);
        }
    };

    return (
        <>
            {label && (
                <label htmlFor={otherProps.id || otherProps.name}>
                    {label}
                    {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
                </label>
            )}
            <DropDownList
                id={otherProps.id || otherProps.name}
                name={field.name}
                data={data}
                value={field.value}
                onBlur={onBlur}
                filterable={filterable}
                onFilterChange={onFilterChange}
                onClose={onClose}
                filter={filter}
                {...otherProps}
                disabled={isDisabled}
                onChange={handleChange}
            />
            <FieldError name={otherProps.name} />
        </>
    );
};
